import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";
import { adminInstance } from '../services/axiosInstance'; // '../axiosInstance';
import { Form, Button, Table, InputGroup, Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function MyRequestPage() {
    const [request, setRequest] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setdata] = useState([]);
       
    useEffect(() => {
        fetchRequest();        
    }, []);

    const fetchRequest = async () => {
        try {
            debugger;
            const response = await adminInstance.get("quoterequest/get");
            setRequest(response.data || []);
            setdata(response.data || []);
        } catch (error) {
            console.error('Error fetching orders:', error.message);
            debugger;
        } finally {
            console.log('Fetch process completed.');
        }
    };

    const navigate = useNavigate();    

    const handleView = (reqId) => {
        navigate(`/MyRequestDetail/${reqId}`);
    }
    
    const filteredData = data
    .filter(spare =>
      spare.ReqCode?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      spare.ReqDate?.toLowerCase().includes(searchTerm.toLowerCase()) 
    );

    return (
        <>

            <>
                <div className="card aon-card">
                    <div className="card-header aon-card-header">
                        <h4>
                            My Quotation Request
                        </h4>
                    </div>
                    <div className="card-body aon-card-body">
                        {
                            <div className="sf-bs-data-table">
                                <div className="table-responsive">
                                    {/* Not  */}
                                    <table className="table table-striped table-bordered example-dt-table aon-booking-table responsive" style={{ width: '100%'}}>
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Code</th>                                                
                                                <th>Date</th>
                                                <th>Customer Code</th>
                                                <th>Customer Name</th>
                                                <th>State</th>
                                                <th>Status</th>
                                                <th>Action</th>                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                        <tr >
                                            <td colSpan={8}>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                                placeholder="Search request..."
                                                value={searchTerm}
                                                onChange={e => setSearchTerm(e.target.value)}
                                            />
                                            </InputGroup>
                                            </td>
                                        </tr>
                                            {
                                                filteredData?.map((emp, index) => {
                                                    return (
                                                        <tr key={uuidv4()}>
                                                            <td>{emp.ReqId}</td>
                                                            <td>{emp.ReqCode}</td>
                                                            <td>{new Date(emp.ReqDate).toLocaleDateString('en-GB', {
                                                                day: '2-digit',
                                                                month: 'short',
                                                                year: 'numeric'
                                                                })}</td>
                                                            <td>{emp.CustomerCode}</td>
                                                            <td>{emp.CustomerName}</td>
                                                            <td>{emp.CustomerState}</td>
                                                            <td>{emp.ReqStatus}</td>
                                                            <td>
                                                                <button className="admin-button wid-200" onClick={() => handleView(emp.ReqId)} style={{marginRight:20}}>View</button>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                          }                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </>

        </>
    );
}

export default MyRequestPage;
